// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1XVTc","title":"Header_title__2g18B","side":"Header_side__29oRC"};